<template>
    <div>
        <vipViewContent :data-set="dataSet" @vIPClaim="VIPClaim" v-model:active="active" :is-tab-view="isTabView"/>
    </div>
</template>
<script setup lang="ts">

import { ref, watch } from 'vue';
import { VipData } from '@/view/vip/supportScript';
import vipViewContent from './components/vipViewContent.vue';

const active = ref(0);

const props = defineProps<{
    dataSet: VipData,
    isTabView?: boolean
}>()
const emit = defineEmits(['vIPClaim', 'update:active'])

const VIPClaim = () => {
    emit('vIPClaim')
}
watch(active, (val) => {
    emit('update:active', val)
})


</script>
<style scoped></style>